import React, { useState, useEffect, useRef } from 'react';
import Layout from '../../components/Layout';
import { API_LINK } from '../../apiLink/apiLink';

const StudentMarks = ({ onNavigate, userInfo }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const [activeTab, setActiveTab] = useState('marks'); // 'marks', 'marksheets'
  const [loading, setLoading] = useState(true);
  const [selectedSemester, setSelectedSemester] = useState('1');
  const [downloading, setDownloading] = useState(null);




  // Student Data
  const [studentData, setStudentData] = useState({
    name: "Loading...",
    studentId: "...",
    cgpa: "0.00",
    attendancePercentage: 0,
    hasPendingFees: false,
    feeAmount: "0",
    semesterName: "...",
    dueDate: "...",
    profileImage: null,
    // Keep these for Hall Ticket usage if API doesn't provide them, 
    // or rely on merge logic to populate them.
    course: "BCA",
    semester: "3",
    dateOfBirth: "2003-05-15",
    enrollmentNo: "SVU2024001"
  });

  // Demo Marks Data - Semester-wise with Internal + External
  const [marksData, setMarksData] = useState({
    '1': [
      {
        subjectCode: 'BCA101',
        subjectName: 'Programming Fundamentals',
        credits: 4,
        internal: { attendance: 8, assignment: 9, classTest: 7, total: 24, maxInternal: 30 },
        external: { theory: 65, practical: 28, total: 93, maxExternal: 100 },
        totalMarks: 117,
        maxMarks: 130,
        grade: 'A',
        status: 'Pass'
      },
      {
        subjectCode: 'BCA102',
        subjectName: 'Data Structures',
        credits: 4,
        internal: { attendance: 9, assignment: 8, classTest: 8, total: 25, maxInternal: 30 },
        external: { theory: 70, practical: 26, total: 96, maxExternal: 100 },
        totalMarks: 121,
        maxMarks: 130,
        grade: 'A+',
        status: 'Pass'
      },
      {
        subjectCode: 'BCA103',
        subjectName: 'Database Management Systems',
        credits: 4,
        internal: { attendance: 7, assignment: 9, classTest: 6, total: 22, maxInternal: 30 },
        external: { theory: 55, practical: 24, total: 79, maxExternal: 100 },
        totalMarks: 101,
        maxMarks: 130,
        grade: 'B+',
        status: 'Pass'
      },
      {
        subjectCode: 'BCA104',
        subjectName: 'Web Technologies',
        credits: 3,
        internal: { attendance: 8, assignment: 10, classTest: 9, total: 27, maxInternal: 30 },
        external: { theory: 72, practical: 29, total: 101, maxExternal: 100 },
        totalMarks: 128,
        maxMarks: 130,
        grade: 'A+',
        status: 'Pass'
      },
      {
        subjectCode: 'BCA105',
        subjectName: 'Mathematics for Computing',
        credits: 3,
        internal: { attendance: 6, assignment: 7, classTest: 8, total: 21, maxInternal: 30 },
        external: { theory: 58, practical: 0, total: 58, maxExternal: 70 },
        totalMarks: 79,
        maxMarks: 100,
        grade: 'B',
        status: 'Pass'
      }
    ],
    '2': [
      {
        subjectCode: 'BCA201',
        subjectName: 'Object Oriented Programming',
        credits: 4,
        internal: { attendance: 9, assignment: 9, classTest: 8, total: 26, maxInternal: 30 },
        external: { theory: 68, practical: 27, total: 95, maxExternal: 100 },
        totalMarks: 121,
        maxMarks: 130,
        grade: 'A+',
        status: 'Pass'
      },
      {
        subjectCode: 'BCA202',
        subjectName: 'Operating Systems',
        credits: 4,
        internal: { attendance: 0, assignment: 0, classTest: 0, total: 0, maxInternal: 30 },
        external: { theory: 0, practical: 0, total: 0, maxExternal: 100 },
        totalMarks: 0,
        maxMarks: 130,
        grade: '-',
        status: 'Pending'
      },
      {
        subjectCode: 'BCA203',
        subjectName: 'Computer Networks',
        credits: 4,
        internal: { attendance: 0, assignment: 0, classTest: 0, total: 0, maxInternal: 30 },
        external: { theory: 0, practical: 0, total: 0, maxExternal: 100 },
        totalMarks: 0,
        maxMarks: 130,
        grade: '-',
        status: 'Pending'
      },
      {
        subjectCode: 'BCA204',
        subjectName: 'Software Engineering',
        credits: 3,
        internal: { attendance: 0, assignment: 0, classTest: 0, total: 0, maxInternal: 30 },
        external: { theory: 0, practical: 0, total: 0, maxExternal: 100 },
        totalMarks: 0,
        maxMarks: 130,
        grade: '-',
        status: 'Pending'
      }
    ],
    '3': [
      {
        subjectCode: 'BCA301',
        subjectName: 'Advanced Java Programming',
        credits: 4,
        internal: { attendance: 0, assignment: 0, classTest: 0, total: 0, maxInternal: 30 },
        external: { theory: 0, practical: 0, total: 0, maxExternal: 100 },
        totalMarks: 0,
        maxMarks: 130,
        grade: '-',
        status: 'Registered'
      },
      {
        subjectCode: 'BCA302',
        subjectName: 'Machine Learning',
        credits: 4,
        internal: { attendance: 0, assignment: 0, classTest: 0, total: 0, maxInternal: 30 },
        external: { theory: 0, practical: 0, total: 0, maxExternal: 100 },
        totalMarks: 0,
        maxMarks: 130,
        grade: '-',
        status: 'Registered'
      },
      {
        subjectCode: 'BCA303',
        subjectName: 'Cloud Computing',
        credits: 3,
        internal: { attendance: 0, assignment: 0, classTest: 0, total: 0, maxInternal: 30 },
        external: { theory: 0, practical: 0, total: 0, maxExternal: 100 },
        totalMarks: 0,
        maxMarks: 130,
        grade: '-',
        status: 'Registered'
      },
      {
        subjectCode: 'BCA304',
        subjectName: 'Mobile App Development',
        credits: 3,
        internal: { attendance: 0, assignment: 0, classTest: 0, total: 0, maxInternal: 30 },
        external: { theory: 0, practical: 0, total: 0, maxExternal: 100 },
        totalMarks: 0,
        maxMarks: 130,
        grade: '-',
        status: 'Registered'
      }
    ]
  });



  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Fetch Student Profile Data
  useEffect(() => {
    const fetchStudentProfile = async () => {
      try {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        if (!token) {
          // If no token, maybe redirect or just stop
          setLoading(false);
          return;
        }

        const response = await fetch(`${API_LINK}/api/student/profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const result = await response.json();
          if (result.success && result.data) {
            setStudentData(prev => ({
              ...prev,
              ...result.data, // Merge API data
              name: result.data.name || userInfo?.name || prev.name,
              studentId: result.data.studentId || userInfo?.id || prev.studentId
              // profileImage will be updated from result.data.profileImage
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching student profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudentProfile();
  }, [userInfo]);











  // Download Provisional Marksheet
  const handleDownloadMarksheet = (semester) => {
    setDownloading(semester);
    setTimeout(() => {
      alert(`📥 Provisional Marksheet for Semester ${semester} download will start shortly.\n\nNote: In production, this will generate and download a PDF document.`);
      setDownloading(null);
    }, 1000);
  };



  // Calculate SGPA/CGPA
  const calculateSGPA = (semesterMarks) => {
    if (!semesterMarks || semesterMarks.length === 0) return 'N/A';

    const gradePoints = { 'A+': 10, 'A': 9, 'B+': 8, 'B': 7, 'C+': 6, 'C': 5, 'D': 4, 'F': 0, '-': 0 };
    let totalCredits = 0;
    let totalGradePoints = 0;

    semesterMarks.forEach(subject => {
      if (subject.grade !== '-' && subject.status === 'Pass') {
        totalCredits += subject.credits;
        totalGradePoints += (gradePoints[subject.grade] || 0) * subject.credits;
      }
    });

    return totalCredits > 0 ? (totalGradePoints / totalCredits).toFixed(2) : 'N/A';
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f4f7fa',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '4px solid #e3f2fd',
          borderTop: '4px solid #238548',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{ color: '#666', fontSize: '1.1rem' }}>Loading Marks Data...</p>
        <style>
          {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
        </style>
      </div>
    );
  }

  return (
    <Layout role="student"
      onNavigate={onNavigate}
      activePage="student-marks"
      pageTitle="Student Marks & Examinations"
    >
      {/* Header Card */}
      <div className="no-print" style={{
        background: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
        marginBottom: '2rem',
        overflow: 'hidden'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #238548 0%, #97d6ac 100%)',
          color: '#ffffff',
          padding: '2rem',
          textAlign: 'center'
        }}>
          <h1 style={{ margin: '0 0 0.5rem 0', fontSize: '2rem', fontWeight: 'bold' }}>
            🎓 Marks & Examinations
          </h1>
          <p style={{ margin: 0, fontSize: '1.1rem', opacity: 0.9 }}>
            Detailed Marks & Provisional Marksheets
          </p>
        </div>

        {/* Tab Navigation */}
        <div style={{ display: 'flex', borderBottom: '1px solid #ecf0f1', flexWrap: 'wrap' }}>
          {[
            { id: 'marks', label: 'Detailed Marks', icon: '📊' },
            { id: 'marksheets', label: 'Marksheets', icon: '📜' }
          ].map((tab) => (
            <button key={tab.id} onClick={() => setActiveTab(tab.id)} style={{
              flex: 1,
              minWidth: isMobile ? '50%' : 'auto',
              background: activeTab === tab.id ? '#238548' : 'transparent',
              color: activeTab === tab.id ? '#ffffff' : '#666',
              border: 'none',
              padding: '1rem',
              cursor: 'pointer',
              fontSize: isMobile ? '0.9rem' : '1rem',
              fontWeight: '500',
              transition: 'all 0.3s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem'
            }}>
              <span>{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>



      {/* Detailed Marks Tab */}
      {activeTab === 'marks' && (
        <div style={{
          background: '#ffffff',
          borderRadius: '12px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
          padding: '2rem'
        }}>
          <h2 style={{ margin: '0 0 1.5rem 0', color: '#238548' }}>
            📊 Detailed Subject-wise Marks
          </h2>

          {/* Semester Selector */}
          <div style={{ marginBottom: '2rem' }}>
            <label style={{ fontWeight: '600', marginRight: '1rem' }}>Select Semester:</label>
            <select value={selectedSemester} onChange={(e) => setSelectedSemester(e.target.value)} style={{
              padding: '0.5rem 1rem',
              borderRadius: '8px',
              border: '2px solid #238548',
              fontSize: '1rem',
              outline: 'none',
              cursor: 'pointer'
            }}>
              {Object.keys(marksData).map(sem => (
                <option key={sem} value={sem}>Semester {sem}</option>
              ))}
            </select>
          </div>

          {/* Marks Table */}
          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '2px solid #238548',
              fontSize: isMobile ? '0.85rem' : '1rem'
            }}>
              <thead>
                <tr style={{ background: '#238548', color: '#fff' }}>
                  <th style={{ padding: '1rem', border: '1px solid #238548', textAlign: 'left' }}>Subject Code</th>
                  <th style={{ padding: '1rem', border: '1px solid #238548', textAlign: 'left' }}>Subject Name</th>
                  <th style={{ padding: '1rem', border: '1px solid #238548', textAlign: 'center' }}>Credits</th>
                  <th colSpan="4" style={{ padding: '1rem', border: '1px solid #238548', textAlign: 'center', background: '#1e7139' }}>
                    Internal Marks (Max 30)
                  </th>
                  <th colSpan="4" style={{ padding: '1rem', border: '1px solid #238548', textAlign: 'center', background: '#145a2e' }}>
                    External Marks (Max 100)
                  </th>
                  <th style={{ padding: '1rem', border: '1px solid #238548', textAlign: 'center' }}>Total</th>
                  <th style={{ padding: '1rem', border: '1px solid #238548', textAlign: 'center' }}>Grade</th>
                  <th style={{ padding: '1rem', border: '1px solid #238548', textAlign: 'center' }}>Status</th>
                </tr>
                <tr style={{ background: '#97d6ac', fontWeight: '600' }}>
                  <th colSpan="3" style={{ padding: '0.5rem', border: '1px solid #238548' }}></th>
                  <th style={{ padding: '0.5rem', border: '1px solid #238548', textAlign: 'center' }}>Attd</th>
                  <th style={{ padding: '0.5rem', border: '1px solid #238548', textAlign: 'center' }}>Assgn</th>
                  <th style={{ padding: '0.5rem', border: '1px solid #238548', textAlign: 'center' }}>Test</th>
                  <th style={{ padding: '0.5rem', border: '1px solid #238548', textAlign: 'center' }}>Total</th>
                  <th style={{ padding: '0.5rem', border: '1px solid #238548', textAlign: 'center' }}>Theory</th>
                  <th style={{ padding: '0.5rem', border: '1px solid #238548', textAlign: 'center' }}>Practical</th>
                  <th style={{ padding: '0.5rem', border: '1px solid #238548', textAlign: 'center' }}>Total</th>
                  <th style={{ padding: '0.5rem', border: '1px solid #238548', textAlign: 'center' }}>Max</th>
                  <th colSpan="3" style={{ padding: '0.5rem', border: '1px solid #238548' }}></th>
                </tr>
              </thead>
              <tbody>
                {marksData[selectedSemester] && marksData[selectedSemester].map((subject, index) => (
                  <tr key={index} style={{ background: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', fontWeight: '600' }}>{subject.subjectCode}</td>
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd' }}>{subject.subjectName}</td>
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center' }}>{subject.credits}</td>

                    {/* Internal Marks */}
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center', background: '#e8f5e9' }}>
                      {subject.internal.attendance || '-'}
                    </td>
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center', background: '#e8f5e9' }}>
                      {subject.internal.assignment || '-'}
                    </td>
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center', background: '#e8f5e9' }}>
                      {subject.internal.classTest || '-'}
                    </td>
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center', fontWeight: '600', background: '#c8e6c9' }}>
                      {subject.internal.total}/{subject.internal.maxInternal}
                    </td>

                    {/* External Marks */}
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center', background: '#e3f2fd' }}>
                      {subject.external.theory || '-'}
                    </td>
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center', background: '#e3f2fd' }}>
                      {subject.external.practical || '-'}
                    </td>
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center', fontWeight: '600', background: '#bbdefb' }}>
                      {subject.external.total}/{subject.external.maxExternal}
                    </td>
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center' }}>
                      {subject.maxMarks}
                    </td>

                    {/* Total & Grade */}
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center', fontWeight: '700', fontSize: '1.1rem', background: '#fff9c4' }}>
                      {subject.totalMarks}
                    </td>
                    <td style={{ padding: '0.75rem', border: '1px solid #ddd', textAlign: 'center', fontWeight: '700', color: subject.grade === 'A+' || subject.grade === 'A' ? '#238548' : '#333' }}>
                      {subject.grade}
                    </td>
                    <td style={{
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      textAlign: 'center',
                      fontWeight: '600',
                      color: subject.status === 'Pass' ? '#238548' : subject.status === 'Pending' ? '#ffc107' : '#666'
                    }}>
                      {subject.status}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{ background: '#238548', color: '#fff', fontWeight: '700', fontSize: '1.1rem' }}>
                  <td colSpan="2" style={{ padding: '1rem', border: '1px solid #238548' }}>SEMESTER {selectedSemester} - SGPA</td>
                  <td colSpan="11" style={{ padding: '1rem', border: '1px solid #238548', textAlign: 'center' }}>
                    {calculateSGPA(marksData[selectedSemester])} / 10.0
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* Legend */}
          <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#f8f9fa', borderRadius: '8px' }}>
            <strong>Legend:</strong>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '0.5rem', marginTop: '0.5rem' }}>
              <span>• Attd = Attendance</span>
              <span>• Assgn = Assignment</span>
              <span>• Test = Class Test</span>
              <span>• SGPA = Semester Grade Point Average</span>
              <span style={{ gridColumn: isMobile ? 'auto' : 'span 2' }}>
                • Grade Scale: A+ (90-100), A (80-89), B+ (70-79), B (60-69), C+ (50-59), C (40-49), D (35-39), F (&lt;35)
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Provisional Marksheets Tab */}
      {activeTab === 'marksheets' && (
        <div style={{
          background: '#ffffff',
          borderRadius: '12px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
          padding: '2rem'
        }}>
          <h2 style={{ margin: '0 0 1.5rem 0', color: '#238548' }}>
            📜 Provisional Marksheets
          </h2>

          <p style={{ color: '#666', marginBottom: '2rem' }}>
            Download semester-wise provisional marksheets in PDF format. These documents are for reference only.
            Official transcripts must be requested from the examination department.
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '1.5rem'
          }}>
            {Object.keys(marksData).map(semester => (
              <div key={semester} style={{
                border: '2px solid #238548',
                borderRadius: '12px',
                padding: '1.5rem',
                transition: 'all 0.3s',
                background: '#f8f9fa'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(35, 133, 72, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                  <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>📜</div>
                  <h3 style={{ margin: '0 0 0.5rem 0', color: '#238548', fontSize: '1.4rem' }}>
                    Semester {semester}
                  </h3>
                  <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
                    SGPA: {calculateSGPA(marksData[semester])} / 10.0
                  </p>
                </div>

                {/* Quick Stats */}
                <div style={{ marginBottom: '1rem', padding: '0.75rem', background: '#fff', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                    <span style={{ fontSize: '0.9rem', color: '#666' }}>Total Subjects:</span>
                    <strong>{marksData[semester].length}</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                    <span style={{ fontSize: '0.9rem', color: '#666' }}>Passed:</span>
                    <strong style={{ color: '#238548' }}>
                      {marksData[semester].filter(s => s.status === 'Pass').length}
                    </strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '0.9rem', color: '#666' }}>Status:</span>
                    <strong style={{ color: marksData[semester].every(s => s.status === 'Pass') ? '#238548' : '#ffc107' }}>
                      {marksData[semester].every(s => s.status === 'Pass') ? 'Completed' :
                        marksData[semester].some(s => s.status === 'Pending') ? 'In Progress' : 'Registered'}
                    </strong>
                  </div>
                </div>

                {/* Download Button */}
                <button
                  onClick={() => handleDownloadMarksheet(semester)}
                  disabled={downloading === semester || marksData[semester].every(s => s.status === 'Registered')}
                  style={{
                    width: '100%',
                    background: downloading === semester ? '#6c757d' :
                      marksData[semester].every(s => s.status === 'Registered') ? '#6c757d' : '#238548',
                    color: '#fff',
                    border: 'none',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    cursor: downloading === semester || marksData[semester].every(s => s.status === 'Registered') ? 'not-allowed' : 'pointer',
                    fontSize: '0.95rem',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    transition: 'all 0.3s'
                  }}
                >
                  {downloading === semester ? (
                    <>
                      <div style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #fff',
                        borderTop: '2px solid transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                      }}></div>
                      Downloading...
                    </>
                  ) : marksData[semester].every(s => s.status === 'Registered') ? (
                    '🚫 Not Available'
                  ) : (
                    <>📥 Download Marksheet</>
                  )}
                </button>
              </div>
            ))}
          </div>

          {/* Important Note */}
          <div style={{
            marginTop: '2rem',
            padding: '1.5rem',
            background: '#fff3cd',
            border: '1px solid #ffc107',
            borderRadius: '8px'
          }}>
            <h4 style={{ margin: '0 0 0.5rem 0', color: '#856404' }}>📌 Important Information:</h4>
            <ul style={{ margin: '0.5rem 0 0 1.5rem', padding: 0, color: '#856404' }}>
              <li>These are provisional marksheets for student reference only</li>
              <li>Official transcripts must be requested from the Examination Department</li>
              <li>Marksheets are available only after results are declared</li>
              <li>For any discrepancies, contact the examination cell immediately</li>
              <li>Keep these documents safe for future reference</li>
            </ul>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default StudentMarks;